import PropTypes from 'prop-types';
import DatasourceBaseOauthNew from "../Datasources/DatasourceBaseOauthNew.jsx";

const DatasourceTeamleader = (props) => {

    const CrmServerTokenController = "/api/teamleader/tokens"
    const ClientId = "98a796f8f61dd85230167cc0f2c6e111"
    const RedirectUrl = "https://auth.cloudcti.nl/webapi/oauth2"
    const AuthUrl = "https://app.teamleader.eu/oauth2/authorize?client_id=" + ClientId + "&response_type=code&redirect_uri=" + RedirectUrl

    return <DatasourceBaseOauthNew SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} CrmServerTokenController={CrmServerTokenController} OnSetReady={props.OnSetReady}/>
}

DatasourceTeamleader.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceTeamleader